import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IDeleteTablesParams {
  ids: string[];
}

export class DeleteTablesRequest extends Request<IDeleteTablesParams, IResult> {
  constructor(params: IDeleteTablesParams) {
    super('deleteTables', params);
  }
}
